import "./sentry";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";
// Import connection test in development
if (import.meta.env.DEV) {
  import("./lib/test-graphql-connection.ts");
}

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary
    fallback={<div>Something went wrong. Please refresh the page.</div>}
  >
    <App />
  </Sentry.ErrorBoundary>
);
